<template>
  <div class="alarm-notification-container">
    <div 
      v-for="notification in notifications" 
      :key="notification.id"
      class="alarm-notification"
      :class="notification.type"
      @click="closeNotification(notification.id)"
    >
      <div class="alarm-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <div class="alarm-content">
        <div class="alarm-title">{{ notification.title }}</div>
        <div class="alarm-message">{{ notification.message }}</div>
        <div class="alarm-time">{{ notification.time }}</div>
      </div>
      <div class="alarm-close">
        <i class="fa fa-times"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlarmNotification',
  data() {
    return {
      notifications: [],
      notificationId: 0
    };
  },
  methods: {
    showNotification(title, message, type = 'alarm') {
      const id = ++this.notificationId;
      const notification = {
        id,
        title,
        message,
        type,
        time: new Date().toLocaleTimeString()
      };
      
      this.notifications.push(notification);
      
      // 移除自动关闭，需要用户手动点击关闭
    },
    closeNotification(id) {
      const notification = this.notifications.find(n => n.id === id);
      this.notifications = this.notifications.filter(n => n.id !== id);
      // 通知父组件，通知已关闭
      this.$emit('notificationClosed', notification);
    }
  }
};
</script>

<style lang="scss" scoped>
.alarm-notification-container {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 600px;
}

.alarm-notification {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
  padding: 32px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  animation: slideIn 0.4s ease-out;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 8px solid;
  min-width: 500px;
  max-width: 600px;
  min-height: 150px;

  &:hover {
    transform: translateX(-10px);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
    scale: 1.05;
  }

  &.alarm {
    border-left-color: #ff4d4f;
    background: #fff;
    animation: slideIn 0.4s ease-out, alarmPulse 1.2s infinite;
    border-top: 2px solid rgba(255, 77, 79, 0.5);
    border-right: 2px solid rgba(255, 77, 79, 0.5);
    border-bottom: 2px solid rgba(255, 77, 79, 0.5);
  }

  &.warning {
    border-left-color: #faad14;
    background: linear-gradient(135deg, rgba(250, 173, 20, 0.3) 0%, rgba(255, 255, 255, 0.98) 100%);
    animation: slideIn 0.4s ease-out, warningPulse 1.5s infinite;
    border-top: 2px solid rgba(250, 173, 20, 0.5);
    border-right: 2px solid rgba(250, 173, 20, 0.5);
    border-bottom: 2px solid rgba(250, 173, 20, 0.5);
  }
}

.alarm-icon {
  font-size: 48px;
  color: #ff4d4f;
  flex-shrink: 0;
  margin-top: 2px;
  animation: iconPulse 1.5s infinite;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.alarm-content {
  flex: 1;
  min-width: 0;
}

.alarm-title {
  font-weight: 800;
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 12px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  letter-spacing: 0.5px;
}

.alarm-message {
  font-size: 20px;
  color: #4b5563;
  margin-bottom: 16px;
  line-height: 1.6;
  font-weight: 600;
}

.alarm-time {
  font-size: 16px;
  color: #9ca3af;
  font-weight: 500;
}

.alarm-close {
  font-size: 24px;
  color: #9ca3af;
  flex-shrink: 0;
  cursor: pointer;
  padding: 12px;
  border-radius: 12px;
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.08);
  margin-left: 16px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
    color: #4b5563;
    transform: rotate(90deg) scale(1.1);
  }
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes alarmPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.4);
  }
  70% {
    box-shadow: 0 0 0 16px rgba(255, 77, 79, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
  }
}

@keyframes warningPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(250, 173, 20, 0.4);
  }
  70% {
    box-shadow: 0 0 0 16px rgba(250, 173, 20, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(250, 173, 20, 0);
  }
}

@keyframes iconPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>